import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { getUserManagementCols } from '../../utils/DataGridConfig';
import { Grid2, Box, CircularProgress } from '@mui/material';
import GenericFilterPanel from '../../components/common/GenericFilterPanel';
import ShowFilterChips from '../../components/common/ShowFilterChips';
import FullScreenActionLoader from '../../components/common/FullScreenActionLoader';
import { GenericConstant } from '../../utils/GenericConstant';
import { getDataGridStyles } from '../../styles/MtComStyleObj';
import { greyHeader } from '../../colors';

const UserManagementGrid: React.FC<any> = (props: any) => {
    const { isFilterVisible, setFilterVisible, listValues, setUsersGridData, getAllUsersListCall, isLoading, userGridData, classes, headerHeight, filterValues, handleDeleteFilter, applyColumnWidths, onColumnWidthChange, deleteUserConfirm, editUserBindData, roleSelected, sortModel, handleSortModelChange, apiRef, setFilterValues, filterDel } = props;
    return (
        <>
            <GenericFilterPanel moduleName='user' listValues={listValues} setGridData={setUsersGridData} onRefreshData={() => getAllUsersListCall({})} isFilterVisible={isFilterVisible} setFilterVisible={setFilterVisible} setFilterFieldData={setFilterValues} filtetToDelete={filterDel} />
            <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                <Box sx={{ maxHeight: 'calc(100vh - 193px)', width: '100%', display: 'flex', flexDirection: 'column', pb: 0, '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F9FAFB', borderBottom: '1px solid #e0e0e0' } }}>
                    <FullScreenActionLoader open={isLoading} />
                    {isLoading ? (
                        <Box sx={{ display: 'flex', placeItems: 'center', justifyContent: 'center' }}><CircularProgress size={32} /></Box>
                    ) : (
                        <Box sx={{ width: '100%' }}>
                            {filterValues?.length > 0 && <Box sx={{ mb: 2 }}><ShowFilterChips filterValues={filterValues} onDelete={handleDeleteFilter} /></Box>}
                            <DataGridPro
                                rows={userGridData ? userGridData : []}
                                columns={applyColumnWidths(getUserManagementCols(deleteUserConfirm, editUserBindData, classes, roleSelected, sortModel))}
                                pageSizeOptions={GenericConstant.USERMGMTPAGINATION}
                                columnHeaderHeight={headerHeight}
                                getRowHeight={() => 'auto'}
                                disableRowSelectionOnClick
                                getRowId={(r) => r?.user_email}
                                hideFooterRowCount
                                pagination
                                apiRef={apiRef}
                                sortModel={sortModel}
                                onSortModelChange={handleSortModelChange}
                                onColumnWidthChange={onColumnWidthChange}
                                initialState={{ pagination: { paginationModel: { pageSize: 50, page: 0 } } }}
                                sx={(theme) => ({ ...getDataGridStyles(theme, { headerColor: greyHeader, fillerColor: greyHeader, maxHeight: 'calc(100vh - 270px)', minHeight: '100px' }), '& .MuiDataGrid-main': { maxHeight: 'calc(100vh - 270px)', overflow: 'auto', minHeight: '100px' } })}
                            />
                        </Box>
                    )}
                </Box>
            </Grid2>
        </>
    );
};

export default UserManagementGrid;
